import "./tag.css";
import { Tag } from './tag';
export default Tag;